import * as React from 'react';
import { SpinnerSize } from "@spscommerce/ds-shared";
import { SpsSpinner } from "@spscommerce/ds-react";

export default function SpsLoadingState() {
    return (
      <div style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0
      }}>
        <div style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          zIndex: 1,
          backgroundColor: "rgba(0, 0, 0, 0.15)"
        }}>
          <SpsSpinner size={SpinnerSize.LARGE} />
        </div>
      </div>
    );
  }